import { useLocalSearchParams } from 'expo-router'

export const useNumberLocalSearchParam = (paramName: string): number | undefined => {
  const params = useLocalSearchParams<Record<string, string>>()
  const value = params[paramName]

  if (!value) return undefined

  const numberValue = Number(value)
  return Number.isNaN(numberValue) ? undefined : numberValue
}
